"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _cloudimageResponsiveUtils = require("cloudimage-responsive-utils");
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _utils = require("./utils");
var _usePrevious = _interopRequireDefault(require("./hooks/usePrevious"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["alt", "className", "lazyLoadConfig", "preserveSize", "imgNodeWidth", "imgNodeHeight"],
  _excluded2 = ["innerRef", "onImgLoad", "disableAnimation", "doNotReplaceURL", "config"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function Img(props) {
  var config = props.config,
    src = props.src,
    placeholderBackground = props.placeholderBackground;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    previewLoaded = _useState4[0],
    setPreviewLoaded = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    loadedImageDim = _useState8[0],
    setLoadedImageDim = _useState8[1];
  var imgNode = (0, _react.useRef)();
  var previousProps = (0, _usePrevious["default"])({
    innerWidth: config.innerWidth,
    src: src
  });
  var server = (0, _react.useMemo)(function () {
    return (0, _cloudimageResponsiveUtils.isServer)();
  }, []);
  var configLazyLoadingValue = config.lazyLoading,
    lazyLoadOffset = config.lazyLoadOffset,
    delay = config.delay,
    innerWidth = config.innerWidth;
  var _props$lazyLoading = props.lazyLoading,
    lazyLoading = _props$lazyLoading === void 0 ? configLazyLoadingValue : _props$lazyLoading;
  var ratio = data.ratio,
    operation = data.operation,
    preview = data.preview,
    previewCloudimgURL = data.previewCloudimgURL,
    cloudimgURL = data.cloudimgURL,
    cloudimgSRCSET = data.cloudimgSRCSET,
    height = data.height;
  var _getFilteredProps = (0, _utils.getFilteredProps)(props),
    alt = _getFilteredProps.alt,
    className = _getFilteredProps.className,
    lazyLoadConfig = _getFilteredProps.lazyLoadConfig,
    preserveSize = _getFilteredProps.preserveSize,
    imgNodeWidth = _getFilteredProps.imgNodeWidth,
    imgNodeHeight = _getFilteredProps.imgNodeHeight,
    otherProps = _objectWithoutProperties(_getFilteredProps, _excluded);
  var innerRef = otherProps.innerRef,
    onImgLoad = otherProps.onImgLoad,
    disableAnimation = otherProps.disableAnimation,
    doNotReplaceURL = otherProps.doNotReplaceURL,
    _config = otherProps.config,
    filteredProps = _objectWithoutProperties(otherProps, _excluded2);
  var getcloudimgSRCSET = function getcloudimgSRCSET() {
    return cloudimgSRCSET.map(function (_ref) {
      var dpr = _ref.dpr,
        url = _ref.url;
      return "".concat(url, " ").concat(dpr, "x");
    }).join(', ');
  };
  var processImg = function processImg(update, windowScreenBecomesBigger) {
    var imageData = (0, _cloudimageResponsiveUtils.processReactNode)(props, imgNode.current, update, windowScreenBecomesBigger);
    if (imageData) {
      setData(imageData);
    }
  };
  var updateLoadedImageSize = function updateLoadedImageSize(image) {
    setLoadedImageDim({
      width: image.naturalWidth,
      height: image.naturalHeight,
      ratio: image.naturalWidth / image.naturalHeight
    });
  };
  var _onImgLoad = function _onImgLoad(event) {
    updateLoadedImageSize(event.target);
    setLoaded(true);
    if (typeof onImgLoad === 'function') {
      onImgLoad(event);
    }
  };
  var onPreviewLoaded = function onPreviewLoaded(event) {
    if (previewLoaded) return;
    var previewImage = event.target;
    updateLoadedImageSize(previewImage);
    setPreviewLoaded(true);
  };
  var pictureStyles = _cloudimageResponsiveUtils.imgStyles.picture({
    preserveSize: preserveSize,
    imgNodeWidth: imgNodeWidth,
    imgNodeHeight: imgNodeHeight,
    ratio: ratio || loadedImageDim.ratio,
    previewLoaded: previewLoaded,
    loaded: loaded,
    placeholderBackground: placeholderBackground,
    operation: operation
  });
  var imageStyles = _cloudimageResponsiveUtils.imgStyles.image({
    preserveSize: preserveSize,
    imgNodeWidth: imgNodeWidth,
    imgNodeHeight: imgNodeHeight,
    operation: operation
  });
  var pictureClassName = "".concat(className, " cloudimage-image ").concat(loaded ? 'loaded' : 'loading').trim();
  (0, _react.useEffect)(function () {
    if (disableAnimation) {
      innerRef.current = imgNode.current;
    }
    if (typeof delay !== 'undefined' && !server) {
      setTimeout(function () {
        processImg();
      }, delay);
    } else {
      processImg();
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!previousProps) return;
    if (previousProps.innerWidth !== innerWidth) {
      processImg(true, innerWidth > previousProps.innerWidth);
    }
    if (src !== previousProps.src) {
      processImg();
    }
  }, [innerWidth, src]);
  var pictureAlt = alt || (0, _cloudimageResponsiveUtils.generateAlt)(src);
  var plainImage = /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread(_objectSpread({}, filteredProps), {}, {
    ref: imgNode,
    className: pictureClassName,
    style: imageStyles,
    alt: pictureAlt
  }, !server && {
    src: cloudimgURL,
    onLoad: _onImgLoad
  }), cloudimgSRCSET && !server && {
    srcSet: getcloudimgSRCSET()
  }));
  var picture = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: pictureClassName,
    style: pictureStyles,
    ref: imgNode,
    children: [preview && operation !== 'bound' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: _cloudimageResponsiveUtils.imgStyles.previewWrapper(),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        style: _cloudimageResponsiveUtils.imgStyles.previewImg({
          loaded: loaded,
          operation: operation
        }),
        src: previewCloudimgURL,
        alt: "low quality preview for ".concat(pictureAlt),
        onLoad: onPreviewLoaded
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread(_objectSpread({}, filteredProps), {}, {
      ref: innerRef,
      alt: pictureAlt,
      style: _cloudimageResponsiveUtils.imgStyles.img({
        preview: preview,
        loaded: loaded,
        operation: operation
      })
    }, !server && {
      src: cloudimgURL,
      onLoad: _onImgLoad
    }), cloudimgSRCSET && !server && {
      srcSet: getcloudimgSRCSET()
    }))]
  });
  var renderedPicture = disableAnimation ? plainImage : picture;
  return lazyLoading && !server ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: imgNode,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLazyload["default"], _objectSpread(_objectSpread({
      height: height,
      offset: lazyLoadOffset
    }, lazyLoadConfig), {}, {
      children: renderedPicture
    }))
  }) : renderedPicture;
}
var _default = Img;
exports["default"] = _default;